import type { IUpdateUserBody } from '../../../../api/types'
import type { UserDescription } from '../../../../types/entitys/users'
import type { UpdateUserPayload } from '../ZodValidationSchema'

/** Пустая строка после trim → null для опциональных текстовых полей API. */
const emptyStringToNull = (value: string): string | null => {
  const trimmed = value.trim()
  return trimmed === '' ? null : trimmed
}

const objectValue = (value: unknown): Record<string, unknown> =>
  value != null && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : {}

const buildProfileMeta = (
  currentMeta: UserDescription['meta'],
  payload: UpdateUserPayload
): Record<string, unknown> => ({
  ...objectValue(currentMeta),
  recommendations: {
    ...objectValue(currentMeta?.recommendations),
    remote_allowed: payload.matchingRemoteAllowed,
  },
})

export const buildUpdateUserRequestBody = (
  payload: UpdateUserPayload,
  initialData?: Pick<UserDescription, 'meta'>
): IUpdateUserBody => ({
  name: payload.name,
  lastname: payload.surname,
  patronymic: emptyStringToNull(payload.otch),
  slug: payload.slug,
  status: payload.status,
  slogan: emptyStringToNull(payload.slogan),
  region: emptyStringToNull(payload.region),
  city: emptyStringToNull(payload.city),
  description: emptyStringToNull(payload.description),
  full_description: emptyStringToNull(payload.full_description),
  work: emptyStringToNull(payload.work),
  birthday: payload.birthday,
  competencies: payload.competencies,
  resources: payload.availableResources,
  participation: payload.conditionsOfParticipation,
  improvements: payload.directionsOfDevelopment,
  meta: buildProfileMeta(initialData?.meta ?? null, payload),
})
